import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/pages/SearchPage/SearchPage.js";
const variants = import.meta.webpackContext("/pages/SearchPage", { recursive: true, regExp: /\.\/__variants__\/plp\-guided\-search\/(?:single|t(?:ext|ile))\/SearchPage\.js/ });
export default pointCut({ joinPoint, variants });